import request from "@/router/axios";

export const getList = (params) => {
  return request({
    url: "/api/produce/alarm-level-config/select/page",
    method: "post",
    data: params,
  });
};

export const getDetail = (id) => {
  return request({
    url: "/api/produce/alarm-level-config/select/id",
    method: "get",
    params: {
      id,
    },
  });
};

export const add = (data) => {
  return request({
    url: "/api/produce/alarm-level-config/insert",
    method: "post",
    data,
  });
};

export const update = (data) => {
  return request({
    url: "/api/produce/alarm-level-config/update",
    method: "post",
    data,
  });
};

export const remove = (id) => {
  return request({
    url: "/api/produce/alarm-level-config/delete/id",
    method: "get",
    params: {
      id,
    },
  });
};

export const changeEnabled = (id, enabled) => {
  return request({
    url: "/api/produce/alarm-level-config/enabled",
    method: "post",
    data: {
      id,
      enabled,
    },
  });
};

export const getUserList = (params) => {
  return request({
    url: "/api/blade-user/page",
    method: "get",
    params,
  });
};

export const getDeptTree = (params = {}) => {
  return request({
    url: "/api/blade-system/dept/tree",
    method: "get",
    params,
  });
};
